module.exports = __webpack_public_path__ + "media/icons/smartsearch/colors/white-60caa1464d22dc5ceb9124a9701eff29.png";